import { createAction } from 'redux-actions'
import * as constants from './constants'
import { api } from 'app/modules/embed/api'

export const fetchEmbed = createAction(constants.FETCH_EMBED)
export const fetchEmbedById = createAction(constants.FETCH_EMBED_BY_ID)
export const fetchEmbedPending = createAction(constants.FETCH_EMBED_PENDING)
export const fetchEmbedFailed = createAction(constants.FETCH_EMBED_FAILED)
export const fetchEmbedSuccess = createAction(constants.FETCH_EMBED_SUCCESS)

export const patchEmbedSuccess = createAction(constants.PATCH_EMBED_SUCCESS)
export const patchEmbedError = createAction(constants.PATCH_EMBED_ERROR)
export const patchEmbedPending = createAction(constants.PATCH_EMBED_PENDING)

export const embedDataAdded = createAction(constants.EMBED_DATA_ADDED)

export const patchEmbed = changes => {
  return dispatch => {
    dispatch(patchEmbedPending())

    api.updateEmbedSettings(changes)
      .then(response => {
        dispatch(patchEmbedSuccess(response))
      })
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/embed/actions.js